/* Chargé en script classique (defer), plus en module : sur les navigateurs
   sans import maps natives (iOS < 16.4, Samsung Internet < 21), Shopify
   injecte un polyfill qui re-télécharge chaque module par fetch — source des
   erreurs « Unable to fetch …/product-card.js ». Encapsulé car la balise peut
   être émise plusieurs fois par page. Un filet de sécurité (délégation de
   clic) est dans snippets/scripts.liquid si ce fichier ne charge pas. */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('product-card')) return;

  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.productUrl = null;
    }

    connectedCallback() {
      this.productUrl = this.dataset.productUrl;

      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      if (event.target instanceof Element) {
        const interactiveElement = event.target.closest(
          'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
        );
        if (interactiveElement) return;
      }

      window.location.href = this.productUrl;
    }
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard);
  }
})();
